var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{ref:"virtualTable"},[_vm._t("default"),_vm._l((_vm.visibleChildren),function(item,itemIndex){return _c(_vm.template,{key:`virtual-item-${itemIndex}`,tag:"div",attrs:{"item":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }